import React, { useRef } from "react";
import { useForm, useFieldArray } from "react-hook-form";

// import Subscribers from "./Subscribers";
// import CaregiverInformation from "./CaregiverInformation";
// import states from "../../helpers/states";
import {
  nameRegex,
  addressRegex,
  cityRegex,
  phoneRegex,
  zipRegex,
  ssn1Regex,
  ssn2Regex,
  ssn3Regex,
  dateRegex,
  emailRegex,
} from "../../helpers/regex";

export default function FundReopenNotificationsForm({ submitHandler }) {
  const {
    register,
    unregister,
    handleSubmit,
    errors,
    watch,
    getValues,
    control,
    setError,
    formState,
  } = useForm({
    defaultValues: {
      role: "patient",
      subscribers: [{}],
    },
  });
  const role = watch("role");

  const ssn2Ref = useRef();
  const ssn3Ref = useRef();

  // Read the formState before render to subscribe the form state through Proxy
  const { isSubmitting } = formState;

  const Intro = () => {
    return (
      <div className="f-scale-body">
        <p className="f-h3 u-mb2">Sign up for this Disease Fund Wait List</p>

        {role === "patient" && (
          <p>
            The patient and the caregiver (if applicable) will be contacted when
            this fund reopens.
          </p>
        )}

        {(role === "provider" || role === "pharmacy") && (
          <p>
            The email subscriber(s) will be contacted when this fund reopens.
          </p>
        )}
      </div>
    );
  };

  return (
    <div className="FundNotificationsForm">
      <Intro />

      <form
        onSubmit={handleSubmit(submitHandler)}
        className="FundNotificationsForm-form u-form"
      >
        {/* <div className="FundNotificationsForm-inputGroup">
          <div className="FundNotificationsForm-input u-mt4">
            <label htmlFor="role">I am a...</label>
            <select name="role" id="role" ref={register}>
              <option value="patient">Patient</option>
              <option value="provider">Provider</option>
              <option value="pharmacy">Pharmacy</option>
            </select>
          </div>
        </div> */}

        <fieldset className="u-mt4">
          <legend className="FundNotificationsForm-legend f-h6 u-mb3 c-default">
            Patient Information
          </legend>

          <div className="FundNotificationsForm-inputGroup">
            <div className="FundNotificationsForm-input u-mb4">
              <label htmlFor="firstName">
                First Name*
                {errors.firstName && errors.firstName.type === "required" && (
                  <span data-validate="error">
                    Please provide your first name.
                  </span>
                )}
                {errors.firstName && errors.firstName.type === "maxLength" && (
                  <span data-validate="error">
                    Can only be a maximum of 50 characters
                  </span>
                )}
                {errors.firstName && errors.firstName.type === "pattern" && (
                  <span data-validate="error">
                    Please provide a valid name.
                  </span>
                )}
              </label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                maxLength="50"
                ref={register({
                  required: true,
                  maxLength: 50,
                  pattern: nameRegex,
                })}
                placeholder="Enter First Name"
              />
            </div>

            {/* <div className="FundNotificationsForm-input u-mb4">
              <label htmlFor="middleName">
                Middle Name
                {errors.middleName &&
                  errors.middleName.type === "maxLength" && (
                    <span data-validate="error">
                      Can only be a maximum of 50 characters
                    </span>
                  )}
                {errors.middleName && errors.middleName.type === "pattern" && (
                  <span data-validate="error">
                    Please provide a valid name.
                  </span>
                )}
              </label>
              <input
                type="text"
                id="middleName"
                name="middleName"
                placeholder="Enter Middle Name"
                maxLength="50"
                ref={register({
                  maxLength: 50,
                  pattern: nameRegex,
                })}
              />
            </div> */}

            <div className="FundNotificationsForm-input u-mb4">
              <label htmlFor="lastName">
                Last Name*
                {errors.lastName && errors.lastName.type === "required" && (
                  <span data-validate="error">
                    Please provide your last name.
                  </span>
                )}
              </label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                maxLength="50"
                ref={register({
                  required: true,
                  maxLength: 50,
                  pattern: nameRegex,
                })}
                placeholder="Enter Last Name"
              />
              {errors.lastName && errors.lastName.type === "required" && (
                <p>Please provide your last name.</p>
              )}
            </div>
          </div>

          <div className="FundNotificationsForm-inputGroup">
            <div className="FundNotificationsForm-input u-mb4">
              <label htmlFor="ssn1">
                <span className="u-screenreader">
                  First 3 digits of patient{" "}
                </span>
                Social security number*
                {(errors.ssn1 || errors.ssn2 || errors.ssn3) && (
                  <span data-validate="error">
                    Please provide a valid social security number.
                  </span>
                )}
              </label>
              <div className="FundNotificationsForm-ssnGroup">
                <input
                  type="password"
                  inputMode="numeric"
                  id="ssn1"
                  name="ssn1"
                  maxLength="3"
                  ref={register({ required: true, pattern: ssn1Regex })}
                  // Progress to second input after 3 characters are entered
                  onChange={(e) => {
                    if (e.target.value.length === 3) {
                      ssn2Ref.current.focus();
                    }
                  }}
                />
                <label htmlFor="ssn2" className="u-screenreader">
                  Fourth and fifth digits of patient social security number
                </label>
                <input
                  type="password"
                  inputMode="numeric"
                  id="ssn2"
                  name="ssn2"
                  maxLength="2"
                  // Progress to third input after 2 characters are entered
                  onChange={(e) => {
                    if (e.target.value.length === 2) {
                      ssn3Ref.current.focus();
                    }
                  }}
                  ref={(e) => {
                    register(e, { required: true, pattern: ssn2Regex });
                    ssn2Ref.current = e;
                  }}
                />
                <label htmlFor="ssn3" className="u-screenreader">
                  Last four digits of patient social security number
                </label>
                <input
                  type="text"
                  inputMode="numeric"
                  id="ssn3"
                  name="ssn3"
                  maxLength="4"
                  ref={(e) => {
                    register(e, { required: true, pattern: ssn3Regex });
                    ssn3Ref.current = e;
                  }}
                />
              </div>
            </div>

            <div className="FundNotificationsForm-input u-mb4">
              <label htmlFor="phone">
                Phone*
                {errors.phone && errors.phone.type === "required" && (
                  <span data-validate="error">
                    Please provide your phone number.
                  </span>
                )}
                {errors.phone && errors.phone.type === "pattern" && (
                  <span data-validate="error">
                    Must be a 10 digit phone number. Do not include spaces,
                    parenthesis, or dashes.
                  </span>
                )}
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                inputMode="numeric"
                maxLength="10"
                placeholder="Enter Phone Number"
                ref={register({ required: true, pattern: phoneRegex })}
              />
            </div>

            {/* <div className="FundNotificationsForm-input u-mb4">
              <label htmlFor="dob">
                Date of birth*
                {errors.dob && errors.dob.type === "required" && (
                  <span data-validate="error">
                    Please provide your date of birth.
                  </span>
                )}
                {errors.dob && errors.dob.type === "pattern" && (
                  <span data-validate="error">
                    Please provide a valid date. Must be formatted as
                    MM/DD/YYYY.
                  </span>
                )}
              </label>
              <input
                type="text"
                id="dob"
                name="dob"
                placeholder="MM/DD/YYYY"
                ref={register({ required: true, pattern: dateRegex })}
              />
            </div> */}

            <div className="FundNotificationsForm-input u-mb4">
              <label htmlFor="email">
                Email*
                {errors.email && errors.email.type === "required" && (
                  <span data-validate="error">
                    Please provide a valid email.
                  </span>
                )}
                {errors.email && errors.email.type === "pattern" && (
                  <span data-validate="error">
                    Please provide a valid email.
                  </span>
                )}
                {errors.email && errors.email.type === "maxLength" && (
                  <span data-validate="error">
                    Must be less than or equal to 100 characters.
                  </span>
                )}
                {errors.email && errors.email.type === "matching" && (
                  <span data-validate="error">Doesn't match</span>
                )}
              </label>
              <input
                type="text"
                inputMode="email"
                id="email"
                name="email"
                maxLength="100"
                placeholder="Enter Email Address"
                ref={register({
                  pattern: emailRegex,
                  maxLength: 100,
                  required: true,
                  validate: {
                    matching: (value) => {
                      const values = getValues();
                      return value === values.confirmEmail;
                    },
                  },
                })}
              />
            </div>


            <div className="FundNotificationsForm-input u-mb4">
              <label htmlFor="confirmEmail">
                Confirm email*
                {errors.confirmEmail &&
                  errors.confirmEmail.type === "required" && (
                    <span data-validate="error">
                      Please provide a valid email
                    </span>
                  )}
                {errors.confirmEmail &&
                  errors.confirmEmail.type === "pattern" && (
                    <span data-validate="error">
                      Please provide a valid email
                    </span>
                  )}
                {errors.confirmEmail &&
                  errors.confirmEmail.type === "maxLength" && (
                    <span data-validate="error">
                      Must be less than or equal to 100 characters.
                    </span>
                  )}
                {errors.confirmEmail &&
                  errors.confirmEmail.type === "matching" && (
                    <span data-validate="error">Doesn't match</span>
                  )}
              </label>
              <input
                type="text"
                inputMode="email"
                id="confirmEmail"
                name="confirmEmail"
                placeholder="Enter Email Address"
                maxLength="100"
                ref={register({
                  pattern: emailRegex,
                  maxLength: 100,
                  required: true,
                  validate: {
                    matching: (value) => {
                      const values = getValues();
                      return value === values.email;
                    },
                  },
                })}
              />
            </div>
          </div>

        </fieldset>

        {/* <fieldset>
          <legend className="FundNotificationsForm-legend f-h6 u-mb3 c-default">
            Patient Address Information
          </legend>

          <div className="FundNotificationsForm-inputGroup">
            <div className="FundNotificationsForm-input FundNotificationsForm-input--block u-mb4">
              <label htmlFor="address">
                Address*
                {errors.address && errors.address.type === "required" && (
                  <span data-validate="error">Please provide an address</span>
                )}
                {errors.address && errors.address.type === "pattern" && (
                  <span data-validate="error">
                    Please provide a valid address
                  </span>
                )}
                {errors.address && errors.address.type === "maxLength" && (
                  <span data-validate="error">
                    Must be less than or equal to 50 characters.
                  </span>
                )}
              </label>
              <input
                type="text"
                id="address"
                name="address"
                placeholder="123 Main Street, Apt. 2"
                maxLength="50"
                ref={register({
                  required: true,
                  pattern: addressRegex,
                  maxLength: 50,
                })}
              />
            </div>

            <div className="FundNotificationsForm-input FundNotificationsForm-input--block u-mb4">
              <label htmlFor="address2">
                Suite/Apt#
                {errors.address && errors.address.type === "pattern" && (
                  <span data-validate="error">
                    Please provide a valid address
                  </span>
                )}
                {errors.address && errors.address.type === "maxLength" && (
                  <span data-validate="error">
                    Must be less than or equal to 50 characters.
                  </span>
                )}
              </label>
              <input
                type="text"
                id="address2"
                name="address2"
                maxLength="50"
                ref={register({
                  pattern: addressRegex,
                  maxLength: 50,
                })}
              />
            </div>

            <div className="FundNotificationsForm-input u-mb4">
              <label htmlFor="city">
                City*
                {errors.city && errors.city.type === "required" && (
                  <span data-validate="error">Please provide a city</span>
                )}
                {errors.city && errors.city.type === "pattern" && (
                  <span data-validate="error">
                    Please provide a valid city name
                  </span>
                )}
                {errors.city && errors.city.type === "maxLength" && (
                  <span data-validate="error">
                    Must be less than or equal to 50 characters.
                  </span>
                )}
              </label>
              <input
                type="text"
                id="city"
                name="city"
                placeholder="City"
                maxLength="50"
                ref={register({
                  required: true,
                  pattern: cityRegex,
                  maxLength: 50,
                })}
              />
            </div>

            <div className="FundNotificationsForm-input u-mb4">
              <label htmlFor="state">
                State*
                {errors.state && errors.state.type === "required" && (
                  <span data-validate="error">Please select a state</span>
                )}
              </label>
              <select
                name="state"
                id="state"
                ref={register({ required: true })}
              >
                <option value="">Select</option>
                {states.map((state, i) => (
                  <option key={i} value={state.abbr}>
                    {state.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="FundNotificationsForm-input u-mb4">
              <label htmlFor="zip">
                ZIP Code*
                {errors.zip && errors.zip.type === "required" && (
                  <span data-validate="error">
                    Please provide your ZIP Code
                  </span>
                )}
                {errors.zip && errors.zip.type === "pattern" && (
                  <span data-validate="error">Must be a 5-digit ZIP Code</span>
                )}
              </label>
              <input
                type="text"
                id="zip"
                name="zip"
                placeholder="5-digit ZIP"
                maxLength="5"
                ref={register({ required: true, pattern: zipRegex })}
              />
            </div>

            <div className="FundNotificationsForm-input u-mb4">
              <label htmlFor="phone">
                Phone*
                {errors.phone && errors.phone.type === "required" && (
                  <span data-validate="error">
                    Please provide your phone number.
                  </span>
                )}
                {errors.phone && errors.phone.type === "pattern" && (
                  <span data-validate="error">
                    Must be a 10 digit phone number. Do not include spaces,
                    parenthesis, or dashes.
                  </span>
                )}
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                inputMode="numeric"
                maxLength="10"
                placeholder="Enter Phone Number"
                ref={register({ required: true, pattern: phoneRegex })}
              />
            </div>
          </div>
        </fieldset> */}

        {/* {role === "patient" && (
          <CaregiverInformation
            register={register}
            unregister={unregister}
            errors={errors}
            getValues={getValues}
          />
        )}

        {(role === "provider" || role === "pharmacy") && (
          <Subscribers
            role={role}
            register={register}
            setError={setError}
            errors={errors}
            useFieldArray={useFieldArray}
            control={control}
            getValues={getValues}
          />
        )} */}

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <button className="btn" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Signing up..." : "Sign Up"}
          </button>
          <span className="f-lumaSansBold c-purple">
            *Required field
          </span>
        </div>
      </form>
    </div>
  );
}
